import React, { useEffect, useState } from "react";
import CustomTable from "../../components/CustomTable";
import { listingGuestUser, listingHistory } from "../../service/Collections";
import { getErrorMessage } from "../../utils/errorMessage";
import { toast } from "react-toastify";
import CustomModal from "../../components/CustomModal";
import ActionPerformed from "../history/ActionPerformed";
import ViewUser from "./ViewUser";
import { TableViewIcon } from "../../utils/SVG";

let defaultPagination = {
  current: 1,
  pageSize: 10,
  total: 0,
};

const GuestUser = () => {
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState(defaultPagination);
  const [totalPage, setTotalPage] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState({});
  const handleModalClick = (data) => {
    setOpenModal(true);
    setSelectedRecord(data);
  };

  const dummyData = [
    {
      key: 1,
      name: "John Doe",
      age: 28,
      email: "john.doe@example.com",
      phone: "123-456-7890",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    },
    {
      key: 2,
      name: "Jane Smith",
      age: 32,
      email: "jane.smith@example.com",
      phone: "987-654-3210",
      description: "Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    },
    {
      key: 3,
      name: "Michael Brown",
      age: 45,
      email: "michael.brown@example.com",
      phone: "456-789-0123",
      description: "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    },
    {
      key: 4,
      name: "Emily Johnson",
      age: 29,
      email: "emily.johnson@example.com",
      phone: "321-654-9870",
      description: "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    },
    {
      key: 5,
      name: "Chris Davis",
      age: 37,
      email: "chris.davis@example.com",
      phone: "789-012-3456",
      description: "Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    },
  ];

  const columns = [
    {
      title: "S.NO",
      dataIndex: "key",
      key: "key",
      render: (text) => (
        <span>{(pagination?.current - 1) * pagination?.pageSize + text}</span>
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 200,
      render: (name) => (
        <span className="capitalize">
          {name}
        </span>
      ),
    },
    {
      title: "Age",
      dataIndex: "age",
      key: "age",
      render: (age) => (
        <span >
          {age}
        </span>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (email) => <span>{email}</span>,
    },
    {
      title: "Phone Number",
      dataIndex: "phone_number",
      key: "phone_number",
      width: 150,
      render: (phone) => <span>{phone}</span>,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (description) => <span style={{
        display: "inline-block",
        maxWidth: "300px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      }}>{description}</span>,
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <div className="flex space-x-2">
          <div
            className="cursor-pointer"
            onClick={() => handleModalClick(record)}
          >
            <TableViewIcon />
          </div>
        </div>
      ),
    },
  ];

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const fetchListing = async () => {
    setLoading(true);
    const { current, pageSize } = pagination;
    let params = new URLSearchParams();
    params.append("perPage", pageSize);
    params.append("page", current);

    let res = await listingGuestUser(params);
    if (res?.status === 200) {
      let addingSno = res?.data?.allguest?.map((u, idx) => ({
        key: idx + 1,
        ...u,
      }));
      setTableData(addingSno);
      setTotalPage(res?.data?.guestCount);
    } else {
      const message = getErrorMessage(res, "Failed to connection");
      toast.error(message);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchListing();
  }, [pagination]);

  return (
    <div>
      <CustomTable
        columns={columns}
        data={tableData}
        heading="Guest Users"
        paginationProps={{
          ...pagination,
          total: totalPage,
        }}
        onChange={handleTableChange}
        loading={loading}
      >
      </CustomTable>

      <CustomModal
        width={789}
        isVisible={openModal}
        onClose={() => setOpenModal(false)}
      >
        <ViewUser selectedRecord={selectedRecord} />
      </CustomModal>
    </div>
  );
};

export default GuestUser;
